const fields = [
  "new", "old", "total", "send", "refuse", "push_sub_uv",
  "push_sub_pv", "push_visit_uv", "push_join_uv", "mp_send", "mp_failed",
];


export function normalizeDailyWelfareComparison(item = {}) {
  return {
    date_label: item.date_label || "-",
    ...Object.fromEntries(fields.map((field) => [field, Number(item[field] || 0)])),
  };
}


export function buildDailyWelfareTrends(items = []) {
  const values = (field) => items.map((item) => Number(item[field] || 0));
  return {
    labels: items.map((item) => item.date_label || "-"),
    subscription: {
      newCount: values("new"),
      oldCount: values("old"),
      sendCount: values("send"),
      refuseCount: values("refuse"),
    },
    conversion: {
      visitCount: values("push_visit_uv"),
      joinCount: values("push_join_uv"),
    },
  };
}
